import React, { PureComponent } from 'react';
import './BasketBanner.scss';

interface OwnProps {
    headerText: string;
    text: string;
    phone: string | number;
}

export class BasketBanner extends PureComponent<OwnProps> {
    render(): JSX.Element {
        const { headerText, text, phone } = this.props;

        return (
            <div className='basket-banner'>
                <h2>{headerText}</h2>
                <p>{text}<span>{phone}</span></p>
            </div>
        );
    }
}